module.exports = __webpack_public_path__ + "img/work.161b41bb.svg";